/* GameDrop.lt theme JS */
(function(){
  'use strict';

  // Add to cart visual feedback
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.product__add');
    if(!btn || btn.tagName === 'A') return;
    var form = btn.closest('form');
    if(!form) return;
    var orig = btn.innerHTML;
    btn.innerHTML = '✓ Pridėta!';
    btn.style.background = 'var(--green)';
    setTimeout(function(){
      btn.innerHTML = orig;
      btn.style.background = '';
    }, 1500);
  });

  // Marquee duplication for seamless scroll
  document.querySelectorAll('.announce__track').forEach(function(track){
    track.innerHTML += track.innerHTML;
  });

  // Newsletter demo
  document.querySelectorAll('.newsletter form').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('button');
      var orig = btn.textContent;
      btn.textContent = '✓ Užsiprenumeravote!';
      setTimeout(function(){ btn.textContent = orig; }, 3000);
    });
  });

  // Scroll reveal
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){
          en.target.style.opacity = '1';
          en.target.style.transform = 'translateY(0)';
          io.unobserve(en.target);
        }
      });
    },{threshold:0.1});
    document.querySelectorAll('.product, .promo').forEach(function(el){
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity .5s, transform .5s';
      io.observe(el);
    });
  }
})();
